import { CaseCustomDistribution } from '../../../specification/cases/CaseSurfaceSpecification';
import { CaseGranulometry } from '../../cases/CaseGranulometry';

export const getLevelCustomDistribution = (
  caseGranulometry: CaseGranulometry,
  levelIndex: number
): CaseCustomDistribution => caseGranulometry.initialSpecifications.customDistribution[levelIndex];
